import styles from "./list.module.css";

function List(props) {
  return (
    <ul className={styles.listUl} aria-label={props["aria-label"]}>
      {props.children}
    </ul>
  );
}

export default List;
